<template>
  <div style="width: 100%; display: flex; justify-content: center">

  <div class="prompt-content">
    <div style="justify-items: flex-start">注：</div>
    <ul>
      <li>
        <span>注册完成后请使用手机验证码进行登录</span>
      </li>
    </ul>
  </div>
  </div>
</template>
<style scoped>
.prompt-content {
  margin-top: 30px;
  margin-bottom: 15px;
  padding-top: 8px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 434px;
  /*height: 72px;*/
  background: inherit;
  background-color: #FFEBE0;
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: #FF5B22;
  border-radius: 5px;
  box-shadow: none;
  color: #FF5B22;
  line-height: 24px;
  font-size: 12px;
}
ul {
  list-style-type: circle; /* 设置点标记为圆圈 */
}
li {
  margin-bottom: 10px; /* 设置子项之间的间距 */
}
</style>
<script setup lang="ts">
</script>